export const  PRIORITY_LIST = [
	// { Value: 0, Label: 'None' }, cells with 0 priority replaced to 4
	{ Value: 1, Label: '1' },
	{ Value: 2, Label: '2' },
	{ Value: 3, Label: '3' },
	{ Value: 4, Label: '4' },
	{ Value: -1, Label: 'Show' }, // show allways 
];